import { RbsDataDto } from '../dtos/rbs-data.dto';
import { RbsData } from '../models/rbs-data';

/**
 * Map model to dto.
 * @param {RbsData} model Model.
 * @returns {RbsDataDto}
 */
function toDto(model) {
  return new RbsDataDto({
    last_name: model.lastName,
    server_id: model.serverId,
    user_id: model.userId,
  });
}

export const rbsDataMapper = {
  toDto,
};
